import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { HomeComponent } from "../home/home.component";
import { Router, RouterLink } from "@angular/router";
import { StudentService } from '../../services/student.service';
import { jwtDecode } from 'jwt-decode';
import { StaffParticularsModel, StudentMaleFemaleModel, YearRow } from '../../models/student.models';
import { CommonModule } from '@angular/common';
import { forkJoin, Subject, switchMap, takeUntil } from 'rxjs';
import { RFinalCgpaDetails } from '../../models/StudentReg';
import { Chart } from 'chart.js/auto';
import { AttendancePercentageComponent } from "../hoddashboard/attendance-percentage/attendance-percentage.component";
import { DayAbsenteesComponent } from "../hoddashboard/day-absentees/day-absentees.component";
import { DeptCircularsComponent } from "../hoddashboard/dept-circulars/dept-circulars.component";
import { DashboardDeptCircularsComponent } from "../hoddashboard/dashboard-dept-circulars/dashboard-dept-circulars.component";
import { PlacementReportComponent } from "../hoddashboard/placement-report/placement-report.component";
import { InternetSpeedsCheckComponent } from '../cc-dashboard/internet-speeds-check/internet-speeds-check.component';
import { ExamRegisterStudentsComponent } from '../examination/exam-register-students/exam-register-students.component';
import { ExamRegisterStudentsRegularComponent } from '../examination/exam-register-students-regular/exam-register-students-regular.component';
import { PaginationComponent } from '../pagination/pagination.component';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';

type StaffFilter = 'total' | 'teaching' | 'nonTeaching';
type StudentFilter = 'total' | '1' | '2' | '3' | '4';
interface GrandTotal {
  sections: {
    [section: string]: { M: number; F: number; total: number };
  };
  total: number;
}

interface Academic {
  academicYearId: number;
  academicFullYear: string;
}

@Component({
  selector: 'app-dashboard',
  imports: [AttendancePercentageComponent, CommonModule,
    AttendancePercentageComponent, DayAbsenteesComponent, RouterLink, PlacementReportComponent,
  InternetSpeedsCheckComponent,ExamRegisterStudentsComponent,ExamRegisterStudentsRegularComponent,
  PaginationComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit, AfterViewInit,OnDestroy {
  private chartRendered = false;
//  @ViewChild('cgpaCanvas') cgpaCanvas!: ElementRef<HTMLCanvasElement>;
@ViewChild('cgpaCanvas')
set canvasSetter(el: ElementRef<HTMLCanvasElement>) {
  if (el) {
    this.cgpaCanvas = el;
    console.log('✅ Canvas created');
    this.renderCgpaChartIfReady();
  }
}
 currentDate: string = new Date().toISOString().split('T')[0]; 
 username: string = '';
 cgpaCanvas!: ElementRef<HTMLCanvasElement>;
 rfinalCgpaDetails: RFinalCgpaDetails[] = [];
 staffParticulars : StaffParticularsModel[] = [];
 teachingStaff: StaffParticularsModel[] = [];
 nonTeachingStaff: StaffParticularsModel[] = [];
 staffFilter : StaffFilter = 'teaching';
 studentFilter : StudentFilter = 'total';
 designationCount: Record<string,number> = {};
 totalCount = 0;
 selectedStaffList: StaffParticularsModel[] = [];
 selectedTitle = '';
 showStaffModal = false;
 private viewReady = false;
 studentGenderStats: StudentMaleFemaleModel[] = [];
 yearWiseGenderSummary: YearRow[] = [];
 allStudents: StudentMaleFemaleModel[] = [];
 selectedStudents: StudentMaleFemaleModel[]=[]; 
 modalTitle = '';
 showModal = false;
 pageSize = 30;
 currentPage = 1;
 staffPageSize = 10;
 staffCurrentPage = 1;
 academicYear = '';
 branchName = '';
 branchId!: number;
 grandTotal: GrandTotal = {
  sections: {},
  total: 0
};
 academicYearId!: number;
 regulationYears: string[] =[];
 groupedCgpa: any = {};
 studentsInGroup: any = {};
 selectedYearLabel = '';   // default
 studentYearLabel = 'Total';
 academicFullYear: string = '';
 academicYears: Academic[] = [];
 attDeptLabel: string = 'CSE';
 cgpaRanges = [
  { label: '9 - 10', min: 9, max: 10 },
  { label: '8 - 8.99', min: 8, max: 8.99 },
  { label: '7 - 7.99', min: 7, max: 7.99 },
  { label: '6 - 6.99', min: 6, max: 6.99 },
  { label: '5 - 5.99', min: 5, max: 5.99 },
  { label: '0', min: 0, max: 4.99 }
];

  semesterToSemester : {[key: number]: string} ={
    1: 'I-Semester',
    2: 'II-Semester',
    3: 'III-Semester',
    4: 'IV-Semester',
    5: 'V-Semester',
    6: 'VI-Semester',
    7: 'VII-Semester',
    8: 'VIII-Semester'
  }


  semesterToYear: { [key: number]: string } = {
  1: 'First Year',
  2: 'First Year',
  3: 'Second Year',
  4: 'Second Year',
  5: 'Third Year',
  6: 'Third Year',
  7: 'Fourth Year',
  8: 'Fourth Year'
};
Math = Math;
cgpaChart?: Chart;
loading: boolean = true;
 designationOrder: string[] = [
  'Principal',
  'Professor',
  'Associate Professor',
  'Assistant Professor (Sr.)',
  'Assistant Professor',
  'Computer Assistant',
  'Lab Assistant',
  'Lab Technician',
  'Lab Attender',
  'DEO Cum Junior Assistant',
  'Data Entry Operator',
  'Attender'
];

designationMap: Record<string, string> = {
  'Professor': 'Professor',
  'Professor & HOD': 'Professor',

  'Associate Professor': 'Associate Professor',
  'Associate Professor & HOD': 'Associate Professor',
  'Associate professor': 'Associate Professor',

  'Assistant Professor (Sr.)': 'Assistant Professor',
  'Assistant Professor (Sr.) and HOD': 'Assistant Professor',

  'Asst. Professor (Sr.)': 'Assistant Professor',

  'Assistant professor': 'Assistant Professor',
  'Asst. Professor': 'Assistant Professor',

  'Assistant Professor': 'Assistant Professor',
  'Asst. professor': 'Assistant Professor',

  'Adjunct Prfofessor': 'Adjunct Professor',
  'Visiting Faculty': 'Adjunct Professor',
};
private destroy$ = new Subject<void>();

 
constructor(private branchService: StudentService,
  private router: Router,
  private zone: NgZone
)
{

}

private resetDashboard() {
  this.rfinalCgpaDetails = [];
  this.groupedCgpa = {};
  // this.cgpaChart?.destroy();
  // this.cgpaChart = undefined!;
}

private tryDrawChart() {
  if (
    !this.cgpaCanvas ||
    !this.rfinalCgpaDetails.length
  ) {
    return;
  }
  console.log('tryDrawChart', {
  canvas: !!this.cgpaCanvas,
  data: this.rfinalCgpaDetails.length,
  chartExists: !!this.cgpaChart
  });
//   setTimeout(() => {
//     if (!this.cgpaChart && this.cgpaCanvas) {
//       console.log("draw cgpa chart");
//       this.drawCgpaBarChart();
//     }
//   this.drawCgpaBarChart();
// },0);
if (this.cgpaChart) {
    this.cgpaChart.destroy();
    this.cgpaChart = undefined!;
  }

  this.drawCgpaBarChart();

}



ngOnInit(){
  this.destroy$ = new Subject<void>();
  this.resetDashboard();
  this.loadStaffParticulars();
  console.log('Dashboard INIT');
}

ngOnDestroy(){
  this.destroy$.next();
  this.destroy$.complete();
  this.zone.runOutsideAngular(()=>{
    if(this.cgpaChart){
      this.cgpaChart.destroy();
      this.cgpaChart = undefined!;
    }
  })
  console.log('Dashboard DESTROY');
}

ngAfterViewInit() {
  this.viewReady = true;
  this.renderCgpaChartIfReady();
}

loadStaffParticulars() {
  console.log("Hai");

  const token = localStorage.getItem('authToken');
  if (!token) return;

  const decodedToken = jwtDecode(token) as { dept: string; branchId: number; username: string };
  this.branchName = decodedToken.dept;
  this.branchId = decodedToken.branchId;
  this.username = decodedToken.username;

  /* -------------------------------
     1️⃣ Academic year → CGPA flow
  --------------------------------*/
  this.branchService.getAcademicYears()
    .pipe(
      takeUntil(this.destroy$),
      switchMap(years => {
        this.academicYearId = years[0]?.academicYearId;
        this.academicYear = years[0]?.academicShortYear;
        this.academicFullYear = years[0]?.academicYear;
        console.log("Academic Year ID is:", years, this.academicYearId);
        for(let i = 0;i<4;i++)
        {
          const startYear = Number(years[0]?.academicShortYear) - i
          const endYear = startYear + 1;
          this.academicYears.push({
            academicYearId: this.academicYearId-i,
            academicFullYear: `${startYear} - ${endYear}`
          })
        }
        console.log("academic Years are:",this.academicYears);
        const startYear = Number(this.academicYear);
          
        this.regulationYears = Array.from({ length: 4 }, (_, i) => {
          const y = startYear - 4 + i;
          return `R${String(y % 100).padStart(2, '0')}`;
        });

        console.log("Regulations years:", this.regulationYears);
        this.selectedYearLabel = `FinalYear(${this.regulationYears[0]}) - (${this.academicYearRegulation(this.academicFullYear,0)})`
        const payload = {
          academicYearId: this.academicYearId - 1,
          deptAcronym: String(this.branchId)
        };

        this.loading = true;
        console.log("Payload for regulations chart:", payload);

        return this.branchService.getStudentRFinalYearDetails(payload);
      })
    )
    .subscribe({
      next: res => {
        this.rfinalCgpaDetails = res;
        
        this.groupCgpaData(res);
        this.calculateTotals();
        this.loading = false;
        this.renderCgpaChartIfReady();
        // setTimeout(()=>{
        //   this.renderCgpaChartIfReady();
        // },0)
        console.log('CGPA records loaded:', res.length);
      },
      error: err => {
        this.loading = false;
        console.error("Academic year / CGPA error:", err);
      }
    });

  /* -----------------------------------
     2️⃣ Staff + Student gender (forkJoin)
  ------------------------------------*/
  forkJoin({
    staff: this.branchService.getStaffParticulars(this.branchName),
    studentgender: this.branchService.getStudentsMaleFemaleParticulars(this.branchName)
  })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: ({ staff, studentgender }) => {

        // Staff data
        this.staffParticulars = staff;
        this.teachingStaff = staff.filter(s => s.employeeType === 'T');
        this.nonTeachingStaff = staff.filter(s => s.employeeType === 'N');
        this.calculateDesignationCount();

        // Student gender data
        this.studentGenderStats = studentgender;
        this.buildYearGenderSummary();
      },
      error: err => {
        console.error("Staff / student gender error:", err);
      }
    });
}



get displayCount(): any {
  switch (this.staffFilter){
    case 'teaching':
      // return this.teachingStaff.length;
      return this.orderedDesignationCounts;
    case 'nonTeaching':
      return this.nonTeachingStaff.length;
    default:
      return this.staffParticulars.length;
  }
}

get filterLabel(): string {
  switch(this.staffFilter){
    case 'teaching': return 'Teaching';
    case 'nonTeaching': return 'NonTeaching';
    default:
      return 'Total';
  }
}

// calculateDesignationCount(){
//   this.designationCountTeaching = this.teachingStaff.reduce(
//     (acc: Record<string,number>,staff) =>{
//       const designation = staff.designation || 'Unknown';
//       acc[designation] = (acc[designation] || 0) + 1;
//       return acc;
//     },
//     {}
//   ) 
// }

calculateDesignationCount() {

  let filteredList = this.staffParticulars;
  if(this.staffFilter === 'teaching'){
    filteredList = this.staffParticulars.filter(s=>s.employeeType === 'T');
  }
  if(this.staffFilter === 'nonTeaching'){
    filteredList = this.staffParticulars.filter(s=>s.employeeType === 'N');
  }
  this.totalCount = filteredList.length;
  this.designationCount = filteredList.reduce(
    (acc: Record<string, number>, staff) => {

      const rawDesignation = staff.designation?.trim();

      const normalizedDesignation =
        this.designationMap[rawDesignation] || rawDesignation;

      acc[normalizedDesignation] =
        (acc[normalizedDesignation] || 0) + 1;

      return acc;
    },
    {}
  );
}


get orderedDesignationCounts() {
  return this.designationOrder.map(designation => ({
    designation,
    count: this.designationCount[designation] || 0
  })).filter(x=>x.count>0);
}

setFilter(filter: StaffFilter) {
  this.staffFilter = filter;
  this.staffCurrentPage = 1;
  this.calculateDesignationCount();
}

openStaffModal(type: string) {

  this.selectedTitle =
    type === 'Total' ? 'All Staff' :
    type === 'Teaching' ? 'Teaching Staff' :
    'Non-Teaching Staff';

  let list = [...this.staffParticulars];

  if (type === 'Teaching') {
    list = list.filter(s => s.employeeType === 'T');
  }

  if (type === 'NonTeaching') {
    list = list.filter(s => s.employeeType === 'N');
  }

  this.selectedStaffList = this.sortByDesignationOrder(list);
  this.staffCurrentPage = 1;
  this.showStaffModal = true;
}

openDesignationModal(designation: string) {

  this.selectedTitle = designation;
  const list = this.staffParticulars.filter(s => {
    const normalized =
      this.designationMap[s.designation?.trim()] || s.designation?.trim();
    return normalized === designation;
  });
  this.selectedStaffList = this.sortByDesignationOrder(list);
  this.staffCurrentPage = 1;
  this.showStaffModal = true;
}

private sortByDesignationOrder(list: StaffParticularsModel[]) {
  return list.sort((a, b) => {
    const rawA = a.designation?.trim() || '';
    const rawB = b.designation?.trim() || '';

    const desA = this.designationMap[rawA] || rawA;
    const desB = this.designationMap[rawB] || rawB;

    const indexA = this.designationOrder.indexOf(desA);
    const indexB = this.designationOrder.indexOf(desB);

    if (indexA !== indexB) {
      return indexA - indexB;
    }

    // If designations are normalized to same value (e.g. Professor & HOD vs Professor)
    // prioritize those with "HOD" in the raw designation
    const isHodA = rawA.toLowerCase().includes('hod');
    const isHodB = rawB.toLowerCase().includes('hod');

    if (isHodA && !isHodB) return -1;
    if (!isHodA && isHodB) return 1;

    // Remaining sort by staffNo (ascending)
    // Handle both numeric and alphanumeric staff numbers
    const numA = parseInt(a.staffNo || '0', 10);
    const numB = parseInt(b.staffNo || '0', 10);

    if (!isNaN(numA) && !isNaN(numB)) {
      return numA - numB;
    }

    return (a.staffNo || '').localeCompare(b.staffNo || '');
  });
}

buildYearGenderSummary(){
  let filtered = this.studentGenderStats;
  if(this.studentFilter !== 'total'){
    filtered = filtered.filter(s=>s.year === Number(this.studentFilter));
  }
  const yearMap = new Map<number,YearRow>();
   const grandTotal: GrandTotal = {
    sections: {},
    total: 0
  };

  filtered.forEach(s => {
    const year = s.year;
    const semester = s.semester;
    const section = s.section;
    const gender = s.genderName === 'Male'? 'M' : 'F';

    if(!yearMap.has(year)){
      yearMap.set(year,{
        year,
        semester,
        sections: {},
        total: 0
      });
    }

    const yearRow = yearMap.get(year)!;
    if(!yearRow.sections[section]){
      yearRow.sections[section] = {M:0,F:0,total:0};
    }

    yearRow.sections[section][gender]++;
    yearRow.sections[section].total++;
    yearRow.total++;

       // ---- Grand Total ----
    if (!grandTotal.sections[section]) {
      grandTotal.sections[section] = { M: 0, F: 0, total: 0 };
    }

    grandTotal.sections[section][gender]++;
    grandTotal.sections[section].total++;
    grandTotal.total++;
  });
this.yearWiseGenderSummary = [...yearMap.values()].sort((a,b)=>a.year - b.year);
this.grandTotal = grandTotal;
}


get allSections(): string[] {
  const set = new Set<string>();
  this.yearWiseGenderSummary.forEach(y =>
    Object.keys(y.sections).forEach(s => set.add(s))
  );
  return [...set].sort(); // A, B, C...
}

openStudentModal(year: number, semester: string, section: string, gender: 'Male' | 'Female' | 'total') {
  if(gender === 'total'){
  this.selectedStudents = this.studentGenderStats.filter(s =>
    s.year === year &&
    s.section === section
  )  
  }
  else{
  this.selectedStudents = this.studentGenderStats.filter(s =>
    s.year === year &&
    s.section === section &&
    s.genderName === gender
  )
}
  // .sort((a,b)=>Number(a.htNo) - Number(b.htNo));
  const sem = this.semesterToSemester[Number(semester)]
  this.modalTitle = `${sem} - Section ${section}`;
  this.currentPage = 1;
  this.showModal = true;
}

openYearTotal(year: number) {
  this.selectedStudents =
    this.studentGenderStats.filter(s => s.year === year);
  this.modalTitle = `Year ${year} - All Students`;
  this.currentPage = 1;
  this.showModal = true;
}

get totalPages(): number {
  return Math.ceil(this.selectedStudents.length / this.pageSize);
}

get totalPagesArray(): number[] {
  return Array.from({ length: this.totalPages }, (_, i) => i + 1);
}

get pageStartIndex(): number {
  return (this.currentPage - 1) * this.pageSize;
}

get paginatedStudents() {
  const start = this.pageStartIndex;
  return this.selectedStudents.slice(start, start + this.pageSize);
}

changePage(page: number) {
  if (page < 1 || page > this.totalPages) return;
  this.currentPage = page;
}

get paginatedStaffList() {
  const start = (this.staffCurrentPage - 1) * this.staffPageSize;
  return this.selectedStaffList.slice(start, start + this.staffPageSize);
}

changeStaffPage(page: number) {
  this.staffCurrentPage = page;
}

closeModal() {
  this.showModal = false;
  this.currentPage = 1;
}

setStudentFilter(filter: StudentFilter){
  this.studentFilter = filter;
  this.studentYearLabel = this.getStudentFilterLabel(filter);
  this.buildYearGenderSummary();
}
getStudentFilterLabel(filter: StudentFilter): string {
  switch(filter){
    case '1': return 'First Year';
    case '2': return 'Second Year';
    case '3': return 'Third Year';
    case '4': return 'Fourth Year';
    default: return 'Total';
  }
}

openGrandTotal(){
  this.selectedStudents = this.studentGenderStats;
  this.currentPage = 1;
  this.showModal = true;
}

openSectionGTotal(section: string){
this.selectedStudents = this.studentGenderStats.filter(s=>s.section === section)
}
openSectionTotal(section:string, gender:string){

    

  this.selectedStudents = this.studentGenderStats.filter(s =>
  s.section === section &&
  s.genderName === gender
)

  // .sort((a,b)=>Number(a.htNo) - Number(b.htNo));
  this.modalTitle = `Section ${section} (${gender})`;
  this.currentPage = 1;
  this.showModal = true;
}

regulationAnalysis(index: number) {
  console.log('Regulation index:', index);

  // const yearMap: Record<number, 'FINAL' | 'THIRD' | 'SECOND' | 'FIRST'> = {
  //   0: 'FINAL',
  //   1: 'THIRD',
  //   2: 'SECOND',
  //   3: 'FIRST'
  // };

  // const yearType = yearMap[index];
  // if (!index) return;

  this.loadYearWiseCgpa(index);
}

previousAcademicYearsAnalysis(id: number){
  console.log("academicYearId is",id);
  this.academicYearId=this.academicYears[id].academicYearId;
  this.academicFullYear = this.academicYears[id].academicFullYear;
}

loadYearWiseCgpa(yearType: number) {
  console.log('Loading CGPA for:', yearType);

  if (this.cgpaChart) {
    this.cgpaChart.destroy();
    this.cgpaChart = undefined!;
  }

  this.loading = true;

  const payload = {
    academicYearId: this.academicYearId - 1,
    deptAcronym: String(this.branchId)
  };

  let api$;

  switch (yearType) {
    case 0:
      api$ = this.branchService.getStudentRFinalYearDetails(payload);
      this.selectedYearLabel='FinalYear' + '('+(this.regulationYears[yearType])+')' + ' - ' +'('+this.academicYearRegulation(this.academicFullYear,0)+')'
      break;

    case 1:
      api$ = this.branchService.getStudentRThirdYearDetails(payload);
      this.selectedYearLabel='ThirdYear'+ '('+(this.regulationYears[yearType])+')' + ' - '+ '('+ this.academicYearRegulation(this.academicFullYear,1)+')'
      break;

    case 2:
      api$ = this.branchService.getStudentRSecondYearDetails(payload);
      this.selectedYearLabel='SecondYear'+'('+(this.regulationYears[yearType])+')' + ' - ' + '('+this.academicYearRegulation(this.academicFullYear,2)+')'
      break;

    case 3:
      api$ = this.branchService.getStudentRFirstYearDetails(payload);
      this.selectedYearLabel='FirstYear'+'('+(this.regulationYears[yearType])+')' + ' - ' + '('+this.academicYearRegulation(this.academicFullYear,3)+')'
      break;
    default:
      console.error('Invalid yearType:', yearType);
      this.loading = false;
      return; // 🔥 IMPORTANT
  }
  api$
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: res => {
        console.log(`${yearType} year data:`, res);

        this.rfinalCgpaDetails = res;
        this.groupCgpaData(res);
        this.calculateTotals();

        this.loading = false;

        // 🔥 VERY IMPORTANT
        setTimeout(() => this.drawCgpaBarChart(), 0);
      },
      error: err => {
        console.error('CGPA API error:', err);
        this.loading = false;
      }
    });
}

academicYearRegulation(year: string,value: number){
  const years = year.split('-')
  switch(value){
    case 0: return (parseInt(years[0]) - 4) + ' - ' + (parseInt(years[1]) - 1);
    case 1: return (parseInt(years[0]) - 3) + ' - ' + (parseInt(years[1]));
    case 2: return (parseInt(years[0]) - 2) + ' - ' + (parseInt(years[1]) + 1);
    case 3: return (parseInt(years[0]) - 1) + ' - ' + (parseInt(years[1]) + 2);
    default:
      return year;
  } 
}


  groupCgpaData(data: any[]) {
  this.groupedCgpa = {};
  this.studentsInGroup = {};

  for (const item of data) {
    const year = this.semesterToYear[item.semester];
    const section = item.section || 'Unknown';
    const cgpaValue = parseFloat(item.cgpa);

    const range = this.cgpaRanges.find(r => cgpaValue >= r.min && cgpaValue <= r.max)?.label || '0';

    this.groupedCgpa[range] = this.groupedCgpa[range] || {};
    this.groupedCgpa[range][year] = this.groupedCgpa[range][year] || {};
    this.groupedCgpa[range][year][section] = this.groupedCgpa[range][year][section] || 0;
    this.groupedCgpa[range][year][section]++;

    const key = `${range}_${year}_${section}`;
    this.studentsInGroup[key] = this.studentsInGroup[key] || [];
    this.studentsInGroup[key].push(item);
  }
}
totalsMap: { [year: string]: { [section: string]: number } } = {};
calculateTotals() {
  this.totalsMap = {};

  for (const range of this.cgpaRanges) {
    const yearMap = this.groupedCgpa[range.label] || {};
    for (const year of Object.keys(yearMap)) {
      if (!this.totalsMap[year]) this.totalsMap[year] = {};

      for (const section of Object.keys(yearMap[year])) {
        const count = yearMap[year][section];
        this.totalsMap[year][section] = (this.totalsMap[year][section] || 0) + count;
      }
    }
  }
  
}


drawCgpaBarChart() {
  this.zone.runOutsideAngular(()=>{
    if (this.cgpaChart) {
      this.cgpaChart.destroy();
      this.cgpaChart = undefined;
    }
    const canvas = this.cgpaCanvas.nativeElement;
    // canvas.width = canvas.parentElement!.clientWidth;
    // canvas.height = 300;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    
    const labels = this.cgpaRanges.map(r => r.label);
    
    const firstYear  = labels.map(l => this.sumSections(this.groupedCgpa[l]?.['First Year']));
    const secondYear = labels.map(l => this.sumSections(this.groupedCgpa[l]?.['Second Year']));
    const thirdYear  = labels.map(l => this.sumSections(this.groupedCgpa[l]?.['Third Year']));
    const fourthYear = labels.map(l => this.sumSections(this.groupedCgpa[l]?.['Fourth Year']));
    console.log("inside draw cgpa chart: ",{
      firstYear,
      secondYear,
      thirdYear,
      fourthYear
    });
    const chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels,
        datasets: [
          { label: 'First Year',  data: firstYear },
          { label: 'Second Year', data: secondYear },
          { label: 'Third Year',  data: thirdYear },
          { label: 'Fourth Year', data: fourthYear }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false, // 🔥 prevents route lag
        plugins: {
          legend: { position: 'top' }
        },
        // scales: {
        //   x: { stacked: true },
        //   y: { stacked: true, beginAtZero: true }
        // }
          scales: {
        x: {
          ticks: {
            autoSkip: false,
            maxRotation: 45,
            minRotation: 0
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 20
          }
        }
      }
      }
    });
    this.zone.run(()=>{
      this.cgpaChart= chart;
    });
  });
}



  sumSections(sectionObj: any): number {
    return Object.values(sectionObj || {}).reduce((a: number, b: any) => a + Number(b), 0);
  }

getSection(row: YearRow, sec: string) {
  return row.sections[sec] ?? { M: 0, F: 0, total: 0 };
}

private renderCgpaChartIfReady() {
  if (!this.viewReady) return;
  if (!this.cgpaCanvas) return;
  if (!this.rfinalCgpaDetails.length) return;

  // if (this.cgpaChart) {
  //   this.cgpaChart.destroy();
  //   this.cgpaChart = undefined;
  // }

  requestAnimationFrame(()=>{
    this.drawCgpaBarChart();
  });

}

getSectionGrandTotal(section: string): number {
  return this.yearWiseGenderSummary.reduce((sum, row) => {
    return sum + (this.getSection(row, section).total || 0);
  }, 0);
}

getYearLabel(year: number): string {
  switch (year) {
    case 1: return 'First Year';
    case 2: return 'Second Year';
    case 3: return 'Third Year';
    case 4: return 'Fourth Year';
    default: return `Year-${year}`;
  }
}

navigateToCgpa() {
  const map: { key: string; route: string }[] = [
    { key: 'final', route: '/cgpa/rfinal' },
    { key: 'third', route: '/cgpa/rthird' },
    { key: 'second', route: '/cgpa/rsecond' },
    { key: 'first', route: '/cgpa/rfirst' }
  ];

  const label = this.selectedYearLabel?.toLowerCase();

  const match = map.find(m => label?.includes(m.key));

  if (match) {
    this.router.navigate([match.route]);
  }
}

openStaffDetails(staffId: string){
  const stfId = Number(staffId)
  switch(this.branchName){
    case 'IT': window.open('https://vce.ac.in/departments/it/it-dept-faculty-details.php?id='+stfId); break;
    case 'CSE': window.open('https://vce.ac.in/departments/cse/cse-dept-faculty-details.php?id='+stfId); break;
    case 'ECE': window.open('https://vce.ac.in/departments/ece/ece-dept-faculty-details.php?id='+stfId); break;
    case 'EEE': window.open('https://vce.ac.in/departments/eee/eee-dept-faculty-details.php?id='+stfId); break;
    case 'MECHANICAL': window.open('https://vce.ac.in/departments/mechanical/mech-dept-faculty-details.php?id='+stfId); break;
    case 'CIVIL': window.open('https://vce.ac.in/departments/civil/civil-dept-faculty-details.php?id='+stfId); break;
    case 'MATHEMATICS': window.open('https://vce.ac.in/departments/maths/mathematics-dept-faculty-details.php?id='+stfId); break;
    case 'PHYSICS': window.open('https://vce.ac.in/departments/physics/physics-dept-faculty-details.php?id='+stfId); break;
    case 'CHEMISTRY': window.open('https://vce.ac.in/departments/chemistry/chemistry-dept-faculty-details.php?id='+stfId); break;
    default: window.open();
  }

}

downloadExcel(){
  if(!this.selectedStudents || this.selectedStudents.length === 0){
    alert("No students selected for download.");
    return;
  }
   const excelData = this.selectedStudents.map((student: any, index: number) => ({
    'S.No': index + 1,
    'HT No': student.htNo,
    'Name': this.toTitleCase(student.studentName),
    'branch': student.branch,
    'Year': student.year,
    'semester': student.semester,
    'section': student.section,
    'Gender': student.genderName,
    'FatherName': this.toTitleCase(student.fatherName),
  }))

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
  const workbook: XLSX.WorkBook = XLSX.utils.book_new();
  
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance Data');

  const filename = `Student_Data_${this.modalTitle}.xlsx`;
  XLSX.writeFile(workbook, filename);

}

downloadPDF(){
  if (!this.selectedStudents || this.selectedStudents.length === 0) {
    alert("No students selected for download.");
    return;
  }

  // 2. Define the columns (headers)
  const columns = [
    { header: 'S.No', dataKey: 'sNo' },
    { header: 'HT No', dataKey: 'htNo' },
    { header: 'Student Name', dataKey: 'name' },
    { header: 'Gender', dataKey: 'gender' },
    { header: 'Father Name', dataKey: 'fatherName' },
  ];

  // 3. Map your student data to match the column dataKeys
  const rows = this.selectedStudents.map((student: any, index: number) => ({
    sNo: index + 1,
    htNo: student.htNo,
    name: this.toTitleCase(student.studentName),
    gender: student.genderName,
    fatherName: this.toTitleCase(student.fatherName),
  }));

  // 4. Initialize jsPDF in landscape mode ('l') to comfortably fit all 10 columns
  const doc = new jsPDF('p','mm','a4' );
  const pageWidth = doc.internal.pageSize.getWidth();
const centerX = pageWidth / 2;

// 2. Main Department Title (Bold & Distinctive)
doc.setFont('helvetica', 'bold');
doc.setFontSize(16);
doc.setTextColor(40, 53, 147); // Dark Indigo/Blue color for a professional look
doc.text("Vasavi College of Engineering(Autonomous)", centerX, 12, { align: 'center' });

// doc.setFont('helvetica', 'bold');
// doc.setFontSize(14);
// doc.setTextColor(40, 53, 147); // Dark Indigo/Blue color for a professional look
// doc.text("Department of " + this.branchName, centerX, 18, { align: 'center' });

// 3. Subheadings (Regular weight, slightly smaller)
doc.setFont('helvetica', 'normal');
doc.setFontSize(12);
doc.setTextColor(80, 80, 80); // Charcoal grey
// doc.text(`Academic Year: ${this.academicYear}`, centerX, 19, { align: 'center' });
doc.text(`Student Particulars of ${this.branchName} - ${this.modalTitle} - (${this.academicFullYear})`, centerX, 17, { align: 'center' });

// 4. Meta Details (Small, subtle gray)
doc.setFontSize(9);
doc.setTextColor(130, 130, 130); // Light grey
// doc.text(`Generated on: ${new Date().toLocaleDateString()}`, centerX, 32, { align: 'center' });

// 5. Generate the table (Make sure to push startY down to 38 so it doesn't overlap)
autoTable(doc, {
  columns: columns,
  body: rows,
  startY: 19, // Shifted down to give the centered header breathing room
  theme: 'striped',
  styles: { fontSize: 9, halign: 'left' },
  headStyles: { fillColor: [66, 133, 244], textColor: 255 }, // Matches the main header color
  columnStyles: {
    sNo: { cellWidth: 15, halign: 'center' },
    percentage: { halign: 'right' }
  }
});


  // 7. Save the generated PDF file
  const filename = `Students_Particulars_${this.modalTitle}.pdf`;
  doc.save(filename);
}

toTitleCase(str: string){
  return str.split(' ').map(st=> st.charAt(0).toUpperCase() + st.slice(1).toLowerCase()).join(' ');
}

}
